import { jsx } from "react/jsx-runtime";
import {
  createContext,
  useState,
  useContext,
  useMemo
} from "react";
const AdjustmentsContext = createContext(
  void 0
);
const AdjustmentsProvider = ({
  children
}) => {
  const [hasPendingAdjustments, setHasPendingAdjustments] = useState(false);
  const [currentLoanAdjustments, setCurrentLoanAdjustments] = useState([]);
  const value = useMemo(
    () => ({
      hasPendingAdjustments,
      setHasPendingAdjustments,
      currentLoanAdjustments,
      setCurrentLoanAdjustments
    }),
    [
      hasPendingAdjustments,
      setHasPendingAdjustments,
      currentLoanAdjustments,
      setCurrentLoanAdjustments
    ]
  );
  return /* @__PURE__ */ jsx(AdjustmentsContext.Provider, { value, children });
};
const useAdjustments = () => {
  const context = useContext(AdjustmentsContext);
  if (context === void 0) {
    throw new Error(
      "useAdjustments must be used within an AdjustmentsProvider"
    );
  }
  return context;
};
export {
  AdjustmentsProvider,
  useAdjustments
};
